import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';
import { GoogleOAuthProvider } from "@react-oauth/google";

// console.log = function() {}
// Wrap the rendering in a function:
const render = Component => {
ReactDOM.render(
  // Wrap App inside AppContainer
  <>
      <GoogleOAuthProvider clientId="56924222872-hd0c43p1948meah9ttt8g7efcdn82hoo.apps.googleusercontent.com">

  <Component /></GoogleOAuthProvider>
  </>,
  document.getElementById('root')
);
};

// Do this once
registerServiceWorker();

// Render once
render(NextApp);

